import React, { useState, useEffect, useRef } from 'react';

function normalize(str) {
  return str?.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '') || '';
}

export default function PersonnelSearch({ personnel, value, onChange, label }) {
  const [inputVal, setInputVal] = useState('');
  const [showSugg, setShowSugg] = useState(false);
  // value actualizado en cada render — para leer la selección vigente dentro
  // del setTimeout de onBlur sin cerrar sobre un valor viejo.
  const valueRef = useRef(value);
  valueRef.current = value;

  useEffect(() => {
    if (value && personnel.length > 0) {
      const found = personnel.find(p => String(p.id) === String(value));
      if (found && inputVal !== found.full_name) setInputVal(found.full_name);
    }
    if (!value) setInputVal('');
  }, [personnel]); // eslint-disable-line

  const words = normalize(inputVal).split(/\s+/).filter(Boolean);
  const isExactMatch = !!personnel.find(p => String(p.id) === String(value) && p.full_name === inputVal);
  const filtered = (words.length === 0 || isExactMatch)
    ? personnel
    : personnel.filter(p => {
        const hay = normalize(p.full_name);
        return words.every(w => hay.includes(w));
      });

  const showDropdown = showSugg && filtered.length > 0;

  return (
    <div style={{ position: 'relative' }}>
      <label style={{ fontSize: 12, color: 'var(--text-dim)', display: 'block', marginBottom: 4 }}>
        {label || 'Responsable'}
      </label>
      <input
        className="input"
        placeholder="Buscar responsable..."
        value={inputVal}
        autoComplete="off"
        onChange={e => {
          setInputVal(e.target.value);
          setShowSugg(true);
          onChange('');
        }}
        onFocus={() => setShowSugg(true)}
        onBlur={() => setTimeout(() => {
          setShowSugg(false);
          // Si al salir no quedó una persona seleccionada, limpiar el texto:
          // así no queda un nombre visible con responsibleId='' (PL5).
          if (!valueRef.current) setInputVal('');
        }, 150)}
        onKeyDown={e => {
          // Sólo confirmar con Enter cuando se está buscando de verdad; con
          // match exacto filtered es la lista completa y Enter reasignaría a
          // la primera persona de todas (PL4).
          if (e.key === 'Enter' && showDropdown && !isExactMatch && filtered.length) {
            e.preventDefault();
            const first = filtered[0];
            setInputVal(first.full_name);
            setShowSugg(false);
            onChange(String(first.id));
          }
        }}
      />
      {showDropdown && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 100,
          background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 6,
          boxShadow: '0 4px 12px rgba(0,0,0,0.3)', marginTop: 2,
          maxHeight: 220, overflowY: 'auto',
        }}>
          {filtered.map(p => (
            <div
              key={p.id}
              onMouseDown={() => {
                setInputVal(p.full_name);
                setShowSugg(false);
                onChange(String(p.id));
              }}
              style={{
                padding: '10px 12px', minHeight: 44, cursor: 'pointer',
                fontSize: 13, display: 'flex', alignItems: 'center',
              }}
              onMouseEnter={e => e.currentTarget.style.background = 'var(--surface2)'}
              onMouseLeave={e => e.currentTarget.style.background = ''}
            >
              {p.full_name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
